import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Container, Stack, Title, Text, Button } from '@mantine/core';
import './i18n'; // на 404-роуте другие страницы не монтируются — инициализируем i18n явно

// id в EspoCRM — 17 символов [a-z0-9]; допускаем 15-20 на случай иных форматов.
const looksLikeId = (s) => /^[a-z0-9]{15,20}$/i.test(s || '');

function NotFound() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const seg = pathname.split('/').filter(Boolean);

  // Если в URL виден id — возвращаем на его дашборд, иначе на главную.
  let backTo = '/';
  let backLabel = t('backToHome');
  if (seg[0] === 'teacher' && looksLikeId(seg[1])) {
    backTo = `/teacher/${seg[1]}`;
    backLabel = t('backToDashboard');
  } else if (looksLikeId(seg[0])) {
    backTo = `/${seg[0]}`;
    backLabel = t('backToDashboard');
  }

  return (
    <Container size={520} style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Stack align="center" gap="md">
        <img src="/logo.png" alt="LingvaPro" style={{ height: 40 }} />
        <Title order={1} style={{ fontSize: 96, lineHeight: 1, color: 'var(--primary, #0ea5e9)' }}>404</Title>
        <Title order={3} ta="center">{t('notFoundTitle')}</Title>
        <Text c="dimmed" ta="center">{t('notFoundText')}</Text>
        <Button component={Link} to={backTo} size="md" mt="sm">{backLabel}</Button>
      </Stack>
    </Container>
  );
}

export default NotFound;
